export const SN_SUMMARY_COLUMNS = [
  { key: "serialNumber", label: "SN" },
  { key: "sequenceNumber", label: "Sequence Number" },
  { key: "productName", label: "Product Name" },
  { key: "serialNumberStatus", label: "SN Status" },
  { key: "assignDate", label: "Assign Date" },
  { key: "distributorName", label: "Distributor Name" },
  { key: "distributorEmail", label: "Distributor Email" },
  { key: "stockoutDate", label: "Stockout Date" },
  { key: "remark", label: "Remark" },
  { key: "scanCount", label: "Scan Count" },
  { key: "scanLimit", label: "Scan Limit" },
  { key: "scanStatus", label: "Scan Status" },
  { key: "consumerName", label: "Consumer Name" },
  { key: "consumerEmail", label: "Consumer Email" },
  { key: "consumerPhoneNumber", label: "Consumer Phone Number" },
  { key: "scanDate", label: "Scan Date" },
  { key: "scanLocation", label: "Scan Location (Google Map Link)" },
];
